/**
 * app相关组件
 * */
//客户端
Vue.component(
    'app-new2',
    resolve => require(["../../components/appNew2"], resolve)
);

//app极速版
Vue.component(
    'app-jisu',
    resolve => require(["../../components/appJisu"], resolve)
);

//app极速版下载弹窗
Vue.component(
    'app-jisu-alert',
    resolve => require(["../../components/appJisu/endAlert"], resolve)
);

//客户端引导
Vue.component(
    'speed-app',
    resolve => require(["../../components/SpeedApp"], resolve)
);

//TV版下载页
Vue.component(
    "tv-com",
    resolve => require(["../../components/TV"], resolve)
);
//TV版指南页
Vue.component(
    "tv-help",
    resolve => require(["../../components/tvHelp"], resolve)
);

//下载app弹窗
Vue.component(
    'download-app',
    resolve => require(["../../components/downloadApp"], resolve)
);
//推荐下载app弹窗
Vue.component(
    'download-app-v2',
    resolve => require(["../../components/downloadApp2"], resolve)
);

// 下载客户端广告other
Vue.component(
    'tips-download-other',
    resolve => require(["../../components/tips/tipsDownloadOther"], resolve)
);

// 下载APP弹窗
Vue.component(
    'download-app-speed',
    resolve => require(["../../components/appDownload/downloadApp"], resolve)
);

//pc客户端
Vue.component(
    'pc-download-introduce',
    resolve => require(["../../components/app/pcDownloadIntroduce"], resolve)
);

// apps下载页面
Vue.component(
    'app-download',
    resolve => require(["../../components/appDownload/AppDownload"], resolve)
);

// 300*250广告位
Vue.component(
    'activitybox-w300-h250',
    resolve => require(["../../components/ads/adW300H250.vue"], resolve)
)

// 1114*200 广告位
Vue.component(
    'activitybox-w1114-h200',
    resolve => require(["../../components/ads/adW1114H200.vue"], resolve)
)

// 1114*200 广告位
Vue.component(
    'activitybox-w1114-h110',
    resolve => require(["../../components/ads/adW1114H110.vue"], resolve)
)

// 274*229 广告位
Vue.component(
    'activitybox-w274-h229',
    resolve => require(["../../components/ads/adW274H229.vue"], resolve)
)

// 550*111 广告位
Vue.component(
    'activitybox-w550-h111',
    resolve => require(["../../components/ads/adW550H111.vue"], resolve)
)

// 254*212广告位
Vue.component(
    'activitybox-w254-h212',
    resolve => require(["../../components/ads/adW254H212.vue"], resolve)
)

// 360*217广告位
Vue.component(
    'ad-w360-h217',
    require("../../components/ads/adW360H217.vue")
)




// WEBPACK FOOTER //
// ./resources/js/signCom/module/app.js